<template>
  <v-menu v-model="menu" :nudge-width="300" offset-y>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip color="black" left>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="black"
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon>mdi-email-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("messanger.chat.send_mail") }}</span>
      </v-tooltip>
    </template>
    <v-card max-width="500" max-height="550">
      <v-row justify="center" align="center">
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Email types</v-list-item-title>
              <v-list-item-subtitle>
                <v-radio-group
                  v-model="$store.state.messages.Send_by_email_select"
                  class="mx-3"
                >
                  <v-radio
                    label="Answer"
                    value="answer"
                    color="black"
                    :disabled="$store.state.chat_user.email ? false : true"
                  >
                  </v-radio>
                  <v-radio
                    label="Transfer"
                    value="transfer"
                    color="black"
                    :disabled="$store.state.chat_user.email ? false : true"
                  >
                  </v-radio>
                  <v-radio
                    label="Transfer without email"
                    value="transfer_without_email"
                    color="black"
                    :disabled="$store.state.chat_user.email ? true : false"
                  >
                  </v-radio>
                  <v-radio
                    label="Transfer Store"
                    value="transfer_store"
                    color="black"
                  ></v-radio>
                </v-radio-group>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "sendbymail",
  data() {
    return {
      type: null,
      menu: null,
    };
  },
  props: {
    mail: null,
  },
  methods: {},
};
</script>
